enum LoggerStatus {
  'debug' = 'debug',
  'info' = 'info',
  'warn' = 'warn',
  'error' = 'error',
  'critical' = 'critical'
}
export default class Logger {
  logInstance: any

  adapter(config: () => {}) {
      if (config) {
          config()
      }
  }

  /**
   * "用于记录系统正常运行情况下有选择地输出的一般信息，强调应用程序的运行过程的完整链路，可以很快对系统中出现的 0~5 级别的错误进行定位。
   * 1. Node.js 端，例如：某个子模块的初始化；
   * 2. 客户端，例如：某个请求的成功执行等。
   * 同时，正常运行也需要监控（无异常不等于正常，也可能没量了）。"
   */
  info(message: string, data: any) {
      this.log(message, data, LoggerStatus.info)
  }
  /**
   * 可能影响系统功能的重要事件，需要及时查看并处理。
   * 1. Node.js 端，例如：某逻辑中某个分支出错，但整体功能尚能完成；
   * 2. 客户端，例如：某逻辑中某个分支出错，但整体功能尚能完成。
   */
  warn(message: string, data: any) {
      this.log(message, data, LoggerStatus.warn)
  }
  /**
   * "运行错误，需要及时检测并处理。不影响整个逻辑的运行，不必要立即进行修复。
   * 1. Node.js 端，例如：某单次逻辑未正常完成处理；
   * 2. 客户端，例如：表单提交失败次数超出重试阈值（3次）。"
   */
  error(message: string, data: any) {
      this.log(message, data, LoggerStatus.error)
  }
  /**
   * 帮助开发、测试、运维人员对系统进行诊断的信息。一般禁止在生产环境输出。
   */
  debug(message: string, data: any) {
      if (process.env.NODE_ENV !== 'production') {
          this.log(message, data, LoggerStatus.debug)
      }
  }
  critical(message: string, data: any) {
      this.log(message, data, LoggerStatus.critical)
  }

  setUserInfo(userInfo: { id: any; name: any; corpId: any; corpIdName: any }) {
      const { id, name, corpId, corpIdName } = userInfo
      this?.logInstance?.setUser({ id, name })
      this?.logInstance?.setGlobalContext({ corpId, corpIdName })
  }

  log(message: string, data: any, status: LoggerStatus) {
      // @ts-ignore
      if (console[status]) {
          // @ts-ignore
          console[status](message, data)
      } else {
          console.log(`【${status}】：`, message, data)
      }
      if (process.env.NODE_ENV === 'production') {
          this?.logInstance?.logger?.[status]?.(JSON.stringify({ log_name: message, ...data }), { log_name: message })
      }
  }
}

